import { c as _c } from "react/compiler-runtime";
import { BCalculatedPriceItemTypeEnum } from '@/types/backend';
import DiscountDetailLine from './DiscountDetailLine';
import FeesDetailLine from './FeesDetailLine';
import SegmentationDetailLine from './SegmentationDetailLine';
import SubTotalDetailLine from './SubTotalDetailLine';
const BookingDetailPriceDetail = (t0) => {
    const $ = _c(19);
    const { items, discountAmount, subTotal, totalPriceBeforeDiscount, fees } = t0;
    let t1;
    if ($[0] !== items) {
        t1 = items.some(_temp);
        $[0] = items;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const hasSpecialTariffs = t1;
    let t2;
    if ($[2] !== hasSpecialTariffs || $[3] !== items) {
        let t3;
        if ($[5] !== hasSpecialTariffs) {
            t3 = (item_0) => <SegmentationDetailLine key={`${item_0.type}-${item_0.nameFr}`} hasSpecialTariffs={hasSpecialTariffs} {...item_0}/>;
            $[5] = hasSpecialTariffs;
            $[6] = t3;
        }
        else {
            t3 = $[6];
        }
        t2 = items.map(t3);
        $[2] = hasSpecialTariffs;
        $[3] = items;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    let t3;
    if ($[7] !== discountAmount) {
        t3 = discountAmount ? <DiscountDetailLine discountAmount={discountAmount}/> : null;
        $[7] = discountAmount;
        $[8] = t3;
    }
    else {
        t3 = $[8];
    }
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
        t4 = <div className="prices-details text-sm py-3">{t2}{t3}
    </div>;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    }
    else {
        t4 = $[11];
    }
    let t5;
    if ($[12] !== fees || $[13] !== subTotal || $[14] !== totalPriceBeforeDiscount) {
        t5 = fees ?
            <div className="total-price py-3 flex flex-col text-sm border-t border-dashed border-gray-100 first:border-0 ">
      <SubTotalDetailLine subTotal={subTotal} totalPriceBeforeDiscount={totalPriceBeforeDiscount}/>

      <FeesDetailLine fees={fees}/>
    </div> : null;
        $[12] = fees;
        $[13] = subTotal;
        $[14] = totalPriceBeforeDiscount;
        $[15] = t5;
    }
    else {
        t5 = $[15];
    }
    let t6;
    if ($[16] !== t4 || $[17] !== t5) {
        t6 = <>{t4}{t5}</>;
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    }
    else {
        t6 = $[18];
    }
    return t6;
};
export default BookingDetailPriceDetail;
function _temp(item) { return item.type === BCalculatedPriceItemTypeEnum.Special; }
